export function downloadFile(blob: Blob, fileName?: string) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName ?? url.split("/").pop() + ".pdf";
    link.click();
    URL.revokeObjectURL(url);
}